import React, { useState } from "react";

/**
 * Profile/avatar image with a letter/icon fallback.
 * Uses the source URL as-is (data: / https: / path) so CSP img-src stays happy —
 * do not convert data URLs to blob: (production CSP does not allow blob: images).
 */
export default function ProfileAvatar({
  src,
  alt = "",
  className = "",
  fallback = null,
  loading = "eager",
}) {
  const value = String(src || "").trim();
  const [failedSrc, setFailedSrc] = useState("");
  const showImage = Boolean(value) && failedSrc !== value;

  if (!showImage) return fallback;

  return (
    <img
      src={value}
      alt={alt}
      className={className}
      loading={loading}
      decoding="async"
      onError={() => setFailedSrc(value)}
    />
  );
}
